import headerComponent from '../../../../templates/components/header.html';
import fullscreenImagePageNavigatorComponent from '../../../../templates/components/fullscreenImagePageNavigator.html';
import breadcrumbsComponent from '../../../../templates/components/breadcrumbs.html';

/**
 * List of components to load on application startup
 */
export const defaultComponents: Record<string, string> = {
  header: headerComponent,
  fullscreenImagePageNavigator: fullscreenImagePageNavigatorComponent,
  breadcrumbs: breadcrumbsComponent,
};
